<template>
  <div class="chapter">
    <div class="image-wrapper">
      <slot name="image"></slot>
    </div>
    <div class="text-wrapper">
      <slot name="header"></slot>
      <slot name="text"></slot>
      <slot name="button"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChapterLeft",
};
</script>

<style lang="scss" scoped>
@import "../scss/shared";
</style>
